import React from 'react'

import { Button, ModalBox, Skeleton, useModalContext } from '@fourthwall/components'

import type { useMemberQuery } from '../../hooks/useMemberQuery'

type Props = {
  member: NonNullable<ReturnType<typeof useMemberQuery>['memberQuery']['data']>
}

export const SubscriptionCancelModalSkeleton = ({ member }: Props) => {
  const modal = useModalContext()

  return (
    <ModalBox
      title={
        <>
          Cancel {member.nickname}'s {member.tier?.name} subscription
        </>
      }
      size="medium"
      buttons={[
        <Button label="Close" appearance="secondary" onClick={modal.close} />,
        <Button label="Confirm cancellation" appearance="destructive" loading />,
      ]}
      onClose={modal.close}
    >
      <Skeleton gap={24}>
        <Skeleton.Shape width="100%" height={104} />
        <Skeleton.Shape width="100%" height={144} />
        <Skeleton.Shape width="100%" height={72} />
      </Skeleton>
    </ModalBox>
  )
}
